export const durationtima: { value: string }[] = [];

for (let i = 0; i < 5; i++) {
    durationtima.push({
        value: i.toString(),
    });
}

for (let i = 5; i < 65; i += 5) {
    durationtima.push({
        value: i.toString(),
    });
}

export function formatNameDoctor(name: string | undefined) {
    if (name) {
        const newName = name.replaceAll(" ", "-");
        return `دکتر-${newName}`;
    }
}

export function formatName(name: string | undefined, prefix?: string) {
    if (name) {
        const newName = name.replaceAll(" ", "-").replaceAll("*", "");
        return `${prefix ? prefix + "-" : ""}${newName}`;
    }
}
